import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AppStore } from '@alfresco/aca-shared/store';

import { getFeatureFlags } from '../store';
import { FEATURE_FLAGS } from '../constants';

export const WkFeatureGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const store = inject(Store<AppStore>);

  return store.select(getFeatureFlags).pipe(
    filter((flags) => Object.keys(flags).length > 0),
    take(1),
    map((flags) => {
      if (flags[FEATURE_FLAGS.ENABLE_APOLLO_AI_FEATURE]) {
        return true;
      }

      return router.createUrlTree(['/search', route.params]);
    })
  );
};
